import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterExtensions } from '@luggagehero/core';
import { EditShopBaseComponent } from '@luggagehero/features/shop-manager';
import { CountryService, PayoutService, StorageManagerService } from '@luggagehero/services';
import { SharedAnalyticsService } from '@luggagehero/shared/services/analytics';
import { SharedErrorService } from '@luggagehero/shared/services/error';
import { SharedGoogleMapsService } from '@luggagehero/shared/services/google-maps';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedPageTaggingService } from '@luggagehero/shared/services/page-tagging';
import { SharedStorageService } from '@luggagehero/shared/services/storage';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-edit-shop',
  templateUrl: 'edit-shop.component.html',
  styleUrls: ['edit-shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class EditShopComponent extends EditShopBaseComponent {
  constructor(
    payoutService: PayoutService,
    windowService: SharedWindowService,
    storageService: SharedStorageService,
    router: RouterExtensions,
    route: ActivatedRoute,
    storageManager: StorageManagerService,
    googleMapsService: SharedGoogleMapsService,
    loginService: SharedUserService,
    error: SharedErrorService,
    tag: SharedPageTaggingService,
    countryService: CountryService,
    notify: SharedNotificationService,
    translate: TranslateService,
    cd: ChangeDetectorRef,
    analytics: SharedAnalyticsService,
  ) {
    super(
      payoutService,
      windowService,
      storageService,
      router,
      route,
      storageManager,
      googleMapsService,
      loginService,
      error,
      tag,
      countryService,
      notify,
      translate,
      cd,
      analytics,
    );
  }
}
